import { defineMessages } from "react-intl";
const messages = defineMessages({
    adminActionsButton: {
        id: "app.admin.adminActions.button.text",
        defaultMessage: "Add New",
    },
    communityOption: {
        id: "app.admin.community.option.text",
        defaultMessage: "Community",
    },
    userOption: {
        id: "app.admin.user.option.text",
        defaultMessage: "User",
    },
    organizationOption: {
        id: "app.admin.organization.option.text",
        defaultMessage: "Organization",
    },
    magicButtonOption: {
        id: "app.admin.magicButton.option.text",
        defaultMessage: "Magic Button",
    },
    betaFeatureOption: {
        id: "app.admin.betaFeature.option.text",
        defaultMessage: "Beta Feature",
    },
});
export default messages;
